// extracted by mini-css-extract-plugin
export default {"message":"ValidationError-module--message--gmKug","innerMessage":"ValidationError-module--innerMessage--hXwHz"};